import React from 'react';
import styles from  './index.module.less';

import { IPickerColumnItemProps } from './index.d';

const ColumnItem = (props: IPickerColumnItemProps) => {
  const { value, active } = props;
  const activeClass = active ? styles.active : null;

  return (
    <div styleName="column-item" className={activeClass}>
      { value }
    </div>
  )
}

export default ColumnItem;